import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/contact/index.jsx");
